import { NgOptimizedImage } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { AssetPipe } from '@libraries/asset/asset.pipe';

@Component({
    selector: 'jsdaddy-grid',
    standalone: true,
    imports: [AssetPipe, NgOptimizedImage],
    templateUrl: './grid.component.html',
    styleUrl: './grid.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridComponent {
    public hideMobile = input(false, { transform: booleanAttribute });
    public hideTablet = input(false, { transform: booleanAttribute });
    public hideDesktop = input(false, { transform: booleanAttribute });
}
